import React, { useEffect, useState } from "react";
import appUrl from "../../../config/MyApp/myAppsURLConfig";
import DefaultAppIcon from "../../../assets/images/defaultAppIcon.svg";
import { TITLE } from "../../../Containers/vendor/MySubscriptions/subscriptionsConstent";

export interface ISubscriptionsListProps {
  subscribedApps: any;

  handelSubscriptionModal: (
    isoprn: boolean,
    title: string,
    appData: any
  ) => void;
}

const SubscriptionsList: React.FC<ISubscriptionsListProps> = (props) => {
  const [copyItem, setCopyItem] = useState<any>({
    isCopied: false,
    appNm: "",
    copiedItem: "",
  });
  const [showApiModal, setApiModal] = useState<any>("");

  const showApiBox = (val: any) => {
    if (window.innerWidth <= 760) {
      setApiModal(val);
      console.log(showApiModal);
    } else {
      setApiModal("");
    }
  };

  const clickToCopy = (e: any, value: string, item: string, app: string) => {
    e.preventDefault();
    setCopyItem({
      isCopied: true,
      appNm: app,
      copiedItem: item,
    });
    navigator.clipboard.writeText(value);
  };

  useEffect(() => {
    if (copyItem.isCopied) {
      setTimeout(() => {
        setCopyItem({
          isCopied: false,
          appNm: "",
          copiedItem: "",
        });
      }, 1000);
    }
  }, [copyItem]);
  return (
    <div>
      <div className="">
        <div className="myAppWrap">
          <div className=" myAppCount"></div>
          <div className="table-responsive">
            <table className="custom-table">
              <thead>
                <tr>
                  <th>
                    <p>Name</p>
                  </th>
                  <th>
                    <p>API Key</p>
                  </th>
                  <th>
                    <p>API Secret Key</p>
                  </th>
                  <th>
                    <p>AppID Key</p>
                  </th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div
                      className="app_logo_with_name"
                      onClick={() => showApiBox(props.subscribedApps)}
                    >
                      <img
                        className="table_app_logo"
                        src={
                          props.subscribedApps.flLnk
                            ? appUrl.appIcon + props.subscribedApps.flLnk
                            : DefaultAppIcon
                        }
                        alt="App Icon"
                      />
                      <h4>{props.subscribedApps.appNm}</h4>
                    </div>
                  </td>
                  <td>
                    <div className="apiKey">
                      <span>{props.subscribedApps.apiKey}</span>
                      <i
                        className="edel-icon-select pointer"
                        onClick={(e) => {
                          clickToCopy(
                            e,
                            props.subscribedApps.apiKey,
                            "Api Key",
                            props.subscribedApps.appNm
                          );
                        }}
                      ></i>
                    </div>
                  </td>
                  <td>
                    <span
                      className="blue-txt pointer"
                      onClick={(e) =>
                        clickToCopy(
                          e,
                          props.subscribedApps.secKey,
                          "Secret Key",
                          props.subscribedApps.appNm
                        )
                      }
                    >
                      Click here to copy
                    </span>
                  </td>
                  <td>
                    <span
                      className="blue-txt pointer"
                      onClick={(e) =>
                        clickToCopy(
                          e,
                          props.subscribedApps.appIdKey,
                          "AppID Key",
                          props.subscribedApps.appNm
                        )
                      }
                    >
                      Click here to copy
                    </span>
                  </td>

                  <td>
                    <p
                      className="pointer grey"
                      onClick={() =>
                        props.handelSubscriptionModal(
                          true,
                          TITLE.EDIT,
                          props.subscribedApps
                        )
                      }
                    >
                      Edit
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="creatBt-mobile">
          {/* <CreateAppBtn updateCreModalValue={createAppBtnHandler} /> */}
        </div>
      </div>

      {copyItem.isCopied && (
        <div className="copied_container">
          <div className="copied_item">
            <p>{`"${copyItem.appNm}" App ${copyItem.copiedItem} Copied`}</p>
          </div>
        </div>
      )}

      {showApiModal !== "" && (
        <div className="modal_api">
          <div className="apiModelContent">
            <div className="closeIcon">
              <i
                className="edel-icon-close"
                onClick={() => {
                  showApiBox("");
                }}
              ></i>
            </div>
            <div className="table-responsive">
              <table className="custom-table">
                <tbody>
                  <tr>
                    <td>
                      <div className="app_logo_with_name">
                        <img
                          className="table_app_logo"
                          src={
                            showApiModal.flLnk
                              ? appUrl.appIcon + showApiModal.flLnk
                              : DefaultAppIcon
                          }
                          alt="app icon"
                        />
                        <span>{showApiModal.appNm}</span>
                      </div>
                    </td>
                    <td>
                      <i className="edel-icon-dots-three-horizontal tooltip"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="copy_section">
              <div className="copy_section_flex">
                <div>
                  <span>Api Key</span>
                  <p>{showApiModal.apiKey}</p>
                </div>
                <button
                  onClick={(e) => {
                    clickToCopy(
                      e,
                      showApiModal.apiKey,
                      "Api Key",
                      showApiModal.appNm
                    );
                  }}
                >
                  Copy
                </button>
              </div>
              <div className="copy_section_flex">
                <div>
                  <span>App Secret Key</span>
                  <p>
                    &#x25cf; &#x25cf; &#x25cf; &#x25cf; &#x25cf; &#x25cf;
                    &#x25cf; &#x25cf;
                  </p>
                </div>
                <button
                  onClick={(e) => {
                    clickToCopy(
                      e,
                      showApiModal.secKey,
                      "Secret Key",
                      showApiModal.appNm
                    );
                  }}
                >
                  Copy
                </button>
              </div>
              <div className="copy_section_flex">
                <div>
                  <span>AppID Key</span>
                  <p>
                    &#x25cf; &#x25cf; &#x25cf; &#x25cf; &#x25cf; &#x25cf;
                    &#x25cf; &#x25cf;
                  </p>
                </div>
                <button
                  onClick={(e) => {
                    clickToCopy(
                      e,
                      showApiModal.appid,
                      "AppID Key",
                      showApiModal.appNm
                    );
                  }}
                >
                  Copy
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriptionsList;
